<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>商户名称、地址或联系方式：</span>
            <a-input v-model="keyword" style="width: 20%" @keypress.enter="handleSearch" />
            <a-button type="primary" style="margin-left: 15px" @click="handleSearch">查询</a-button>
        </div>

        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
            <template slot="pointAction" slot-scope="text, record">
                <a-button type="link" style="padding: 0; margin-left: 10px" @click="$refs.pointCharge.showForm(record, 'charge')">充值</a-button>
                <a-button type="link" style="padding: 0; margin-left: 15px" @click="$refs.pointCharge.showForm(record)">扣减</a-button>
                <a-divider type="vertical"/>
                <a-button type="link" style="padding: 0; margin-left: 15px" @click="$refs.pointLog.showModal('积分变动记录', record.id)">变动记录</a-button>
            </template>
            <template slot="action" slot-scope="text, record">
<!--                <a-button type="link" @click="$refs.ownerView.showModal(record.ownerId)">店主信息</a-button>-->
                <a-button type="link" @click="$refs.couponModal.showModal(`'${record.vendorName}'消费券列表`, record.id)">消费券列表</a-button>
                <a-button type="link" @click="$refs.editForm.showForm(record)">资料修改</a-button>
                <a-button type="link" @click="handleDeleteVendor(record)">删除商家</a-button>
            </template>
        </a-table>
        <edit-form ref="editForm" @submit="handleEdit"></edit-form>
<!--        <owner-view ref="ownerView" ></owner-view>-->
        <!--积分记录-->
        <point-log-modal ref="pointLog"></point-log-modal>
        <!--消费券列表-->
        <coupon-modal ref="couponModal"></coupon-modal>
        <!--充值、扣减-->
        <point-charge-modal ref="pointCharge" @charge="handleCharge" @deduct="handleDeduct"></point-charge-modal>
    </div>
</template>

<script>
    import vendorService from '@/service/vendor'
    import moment from 'moment'
    import OwnerView from "./~OwnerView";
    import Icon from "ant-design-vue/es/icon";
    import EditForm from "./EditForm";
    import PointLogModal from "./PointLogModal";
    import PointChargeModal from "./PointChargeModal";
    import CouponModal from "./CouponModal";

    export default {
        name: "VendorList",
        components: { OwnerView, EditForm, PointLogModal, PointChargeModal, CouponModal},
        data() {
            return {
                columns: [
                    {title: '#', width: "5%", scopedSlots: { customRender: 'serial' }},
                    {title: '名称',width: "18%", dataIndex: 'vendorName',},
                    {title: '地址',width: "20%", dataIndex: 'address', },
                    {title: '联系方式',width: "12%", dataIndex: 'phone', },
                    {title: '积分',width: "5%", dataIndex: 'point', colSpan: 2},
                    {title: '积分操作',width: "15%", dataIndex: 'pointAction', scopedSlots: {customRender: 'pointAction'}, colSpan: 0},
                    {title: '更新时间',width: "10%", dataIndex: 'updateTime', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                    {title: '操作',width: "15%", dataIndex: 'action', scopedSlots: {customRender: 'action'}}
                ],
                rows: [],
                pagination: {},
                keyword: ''
            };
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            handleSearch() {
                this.fetch({
                    pageNo: 1,
                    pageSize: 5,
                    keyword: this.keyword,
                })
            },
            fetch(params) {
                vendorService.getVendorList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.records
                    pagination.current = res.data.current
                    pagination.total = res.data.total
                    pagination.pageSize = res.data.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }
                    this.pagination = pagination
                });
            },

            handleEdit(values) {
                vendorService.edit( values).then((res) => {
                    if(res.data.success) {
                        this.$notification.open({
                            message: '修改成功！',
                            description: res.data.message,
                        });
                        let params = {
                            pageNo: 1,
                            pageSize: 5,
                        }
                        this.fetch(params)
                    } else {
                        this.$notification.open({
                            message: '修改失败！',
                            description: res.data.message,
                            icon: (h) => {
                                return h(Icon, {
                                    attrs: {type: 'close-circle', style: 'color: red'}
                                });
                            }
                        });
                    }
                })
            },
            handleDeleteVendor(record) {
                let vm = this
                this.$confirm({
                    title: '风险操作，请确认！',
                    content: `您将要删除名为"${record.vendorName}"的商家，确认吗？`,
                    okText: "确定",
                    cancelText: "取消",
                    onOk() {
                        vm.$confirm({
                            title: '请再次确认！',
                            content: `删除商家"${record.vendorName}"后将不再展示，请再次确认！`,
                            okText: "确定",
                            cancelText: "取消",
                            onOk() {
                                vendorService.disable({id: record.id}).then((res) => {
                                    vm.$notification.open({
                                        message: '删除成功！',
                                        description: res.data.message,
                                    });
                                    let params = {
                                        pageNo: vm.pagination.current,
                                        pageSize: 5,
                                        keyword: vm.keyword
                                    }
                                    vm.fetch(params)
                                })
                            }
                        })
                    },
                });
            },
            handleCharge(values) {
                vendorService.pointCharge(values).then((res) => {
                    if(res.data.success) {
                        this.$notification.open({
                            message: '充值成功！',
                            description: res.data.message,
                        });
                        let params = {
                            pageNo: this.pagination.current,
                            pageSize: 5,
                            keyword: this.keyword
                        }
                        this.fetch(params)
                    } else {
                        this.$notification.open({
                            message: '充值失败！',
                            description: res.data.message,
                            icon: (h) => {
                                return h(Icon, {
                                    attrs: {type: 'close-circle', style: 'color: red'}
                                });
                            }
                        });
                    }
                })
            },
            handleDeduct(values) {
                vendorService.pointDeduct(values).then((res) => {
                    if(res.data.success) {
                        this.$notification.open({
                            message: '扣减成功！',
                            description: res.data.message,
                        });
                        let params = {
                            pageNo: this.pagination.current,
                            pageSize: 5,
                            keyword: this.keyword
                        }
                        this.fetch(params)
                    } else {
                        this.$notification.open({
                            message: '扣减失败！',
                            description: res.data.message,
                            icon: (h) => {
                                return h(Icon, {
                                    attrs: {type: 'close-circle', style: 'color: red'}
                                });
                            }
                        });
                    }
                })
            }
        }
    }
</script>
